<template>
  <NavigationComponent>
    <FolieMitBild
      title="Einführung in Vue.js"
      imgsrc="https://raw.githubusercontent.com/vuejs/art/master/logo.png"
    >
      <p>veröffentlicht im Februar 2014</p>
      <p>entwickelt von Evan You als einfachere Alternative zu Angular.js</p>
      <v-divider></v-divider>
      <p class="caption">
        Bildquelle: Evan You (https://github.com/vuejs/art/)
      </p>
    </FolieMitBild>
  </NavigationComponent>
</template>

<script>
import FolieMitBild from "../components/FolieMitBild";
import NavigationComponent from "../components/NavigationComponent";
export default {
  name: "Einführung",
  components: { NavigationComponent, FolieMitBild }
};
</script>

<style scoped></style>
